import { render, staticRenderFns } from "./GoodsCoupon.vue?vue&type=template&id=19a08032&scoped=true&"
import script from "./GoodsCoupon.vue?vue&type=script&lang=js&"
export * from "./GoodsCoupon.vue?vue&type=script&lang=js&"
import style0 from "./GoodsCoupon.vue?vue&type=style&index=0&id=19a08032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a08032",
  null
  
)

export default component.exports